import { type ListType, MEASUREMENT_SYSTEM, YesNoEnum } from '@/models/app';
import { RideServiceType } from '@/models/ride';

export const tinymceApiKey = import.meta.env.VITE_TINYMCE_API_KEY;

export const gogoMainNumber = '+18554646872';
export const gogoMainOutboundNumber = '+18556084646';
export const gourmetNumber = '+18557545328';
export const groceryNumber = '+18552224919';
export const groceryOutboundNumber = '+18556384646';
export const gogoCareNumber = '+18554646603';
export const gogoHomeServicesNumber = '+18554646771';
export const gogoAUMainNumber = '+61134628';
export const gogoAUOutboundNumber = '+61483928100';

export const gogoInternalNumbers = [
  gogoMainNumber,
  gogoMainOutboundNumber,
  gourmetNumber,
  groceryNumber,
  groceryOutboundNumber,
  gogoCareNumber,
  gogoHomeServicesNumber,
  gogoAUMainNumber,
  gogoAUOutboundNumber,
];

export const commonDateTimeFormat = 'ddd, MM-DD-YYYY hh:mm A';
export const dateTimeFormat = 'YYYY-MM-DD HH:mm:ss';
export const dateFormat = 'YYYY-MM-DD';
export const timeOnlyFormat = 'HH:mm:ss';
export const googleRadius = 1609;
export const milesExchange = 1.60934; // 1 miles = 1.60934 km
export const defaultGroceryTipPercentage = 5;
export const emailPattern = '^\\w+([\\.-]?\\w+)*@\\w+([\\.-]?\\w+)*(\\.\\w{2,})+$';
export const defaultTimeZone = 'America/New_York';
export const viewVirtualDashboardKey = 'viewVirtualDashboard';
export const tokenExpiredText = 'Token expired';

export const unitsTypes: ListType[] = [
  { id: 1, key: MEASUREMENT_SYSTEM.METRIC, label: 'Metric' },
  { id: 2, key: MEASUREMENT_SYSTEM.IMPERIAL, label: 'Imperial' },
];

export const currencyTypes: ListType[] = [
  { id: 1, key: 'USD', label: 'USD' },
  { id: 2, key: 'CAD', label: 'CAD' },
];

export const alreadyDiscussedList: ListType[] = [
  { id: 1, key: 'how-gogo-works', label: 'How GoGo works' },
  { id: 2, key: 'membership-pricing', label: 'Membership Pricing' },
  { id: 3, key: 'collected-details-for-soft-register', label: 'Collected details for soft register' },
];

export const departmentList: ListType[] = [
  { id: 1, key: 'rides', label: 'Rides' },
  { id: 2, key: 'groceries', label: 'Groceries' },
  { id: 3, key: 'gourmet', label: 'Gourmet' },
  { id: 4, key: 'homeServices', label: 'Home Services' },
];

export const transporationList: ListType[] = [
  { id: 1, key: 'Family/Friend is driving them', label: 'Family/Friend is driving them' },
  { id: 2, key: 'Moved to assisted living facility', label: 'Moved to assisted living facility' },
  { id: 3, key: 'City transit or another more affordable service', label: 'City transit or another more affordable service' },
  { id: 4, key: 'Free/insurance transportation service', label: 'Free/insurance transportation service' },
  { id: 5, key: 'Caregiver who will be driving them', label: 'Caregiver who will be driving them' },
];

export const timeZoneList: ListType[] = [
  { id: 1, key: 'America/Los_Angeles', label: 'America/Los_Angeles' },
  { id: 2, key: 'America/New_York', label: 'America/New_York' },
  { id: 3, key: 'America/Chicago', label: 'America/Chicago' },
  { id: 4, key: 'America/Denver', label: 'America/Denver' },
  { id: 5, key: 'America/Phoenix', label: 'America/Phoenix' },
  { id: 6, key: 'America/Anchorage', label: 'America/Anchorage' },
  { id: 7, key: 'America/Adak', label: 'America/Adak' },
  { id: 8, key: 'America/Detroit', label: 'America/Detroit' },
  { id: 9, key: 'Australia/Adelaide', label: 'Australia/Adelaide' },
  { id: 10, key: 'Australia/Brisbane', label: 'Australia/Brisbane' },
  { id: 11, key: 'Australia/Broken_Hill', label: 'Australia/Broken_Hill' },
  { id: 12, key: 'Australia/Darwin', label: 'Australia/Darwin' },
  { id: 13, key: 'Australia/Eucla', label: 'Australia/Eucla' },
  { id: 14, key: 'Australia/Hobart', label: 'Australia/Hobart' },
  { id: 15, key: 'Australia/Lindeman', label: 'Australia/Lindeman' },
  { id: 16, key: 'Australia/Lord_Howe', label: 'Australia/Lord_Howe' },
  { id: 17, key: 'Australia/Melbourne', label: 'Australia/Melbourne' },
  { id: 18, key: 'Australia/Perth', label: 'Australia/Perth' },
  { id: 19, key: 'Australia/Sydney', label: 'Australia/Sydney' },
];

export const vendorTypeList: ListType[] = [
  { id: 1, key: 'Lyft', label: 'Lyft' },
  { id: 2, key: 'Uber', label: 'Uber' },
];

export const rideServiceTypeList: ListType[] = [
  { id: 1, key: RideServiceType.Transportation, label: 'Transportation' },
  { id: 2, key: RideServiceType.PharmacyDelivery, label: 'Pharmacy Delivery' },
  { id: 3, key: RideServiceType.SpecialRequest, label: 'Special Request' },
];

export const languageList: ListType[] = [
  { id: 1, key: '', label: 'None' },
  { id: 2, key: 'en', label: 'English' },
  { id: 3, key: 'es', label: 'Spanish' },
];

export const availableRolesForPage: {
  pageId: string;
  allowedRoles: string[];
}[] = [
  {
    pageId: 'operator',
    allowedRoles: [
      'admin',
      'director',
      'supervisor',
      'supervisorTeamLead',
      'operator',
      'teamLead',
      'rideTeamLead',
      'gourmet-supervisor',
      'gourmet-operator',
      'lossPrevention',
      'qualityAssurance',
      'grocery-operator',
      'grocery-manager',
      'partnership-operator',
      'lossPreventionGourmet',
      'lossPreventionGrocery',
      'virtualAssistanceGrocery',
      'research-operator',
      'onboarding-team-lead',
      'delivery-operator',
      'affiliate-manager',
      'partnership-caller-operator',
      'bookings-operator',
      'doortodoor-operator',
      'homeServices-operator',
      'gogocare-operator',
      'cozy-operator',
      'research-admin',
      'pharmacy-registrations-operator',
      'pharmacy-operator',
      'gogo-welcome-operator',
      'partnership-registrations-operator',
      'ride-registrations-operator',
      'gourmet-registrations-operator',
      'grocery-registrations-operator',
      'delivery-registrations-operator',
      'gogocare-registrations-operator',
      'research-registrations-operator',
      'partnership-caller-registrations-operator',
      'homeServices-registrations-operator',
      'facebookLeads-registrations-operator',
      'overseas-operator',
    ],
  },
  {
    pageId: 'family',
    allowedRoles: [
      'admin',
      'director',
      'supervisor',
      'supervisorTeamLead',
      'operator',
      'teamLead',
      'rideTeamLead',
      'gourmet-supervisor',
      'gourmet-operator',
      'lossPrevention',
      'qualityAssurance',
      'grocery-operator',
      'grocery-manager',
      'partnership-operator',
      'lossPreventionGourmet',
      'lossPreventionGrocery',
      'virtualAssistanceGrocery',
      'research-operator',
      'onboarding-team-lead',
      'delivery-operator',
      'affiliate-manager',
      'partnership-caller-operator',
      'bookings-operator',
      'doortodoor-operator',
      'homeServices-operator',
      'gogocare-operator',
      'cozy-operator',
      'research-admin',
      'pharmacy-registrations-operator',
      'pharmacy-operator',
      'gogo-welcome-operator',
      'partnership-registrations-operator',
      'ride-registrations-operator',
      'gourmet-registrations-operator',
      'grocery-registrations-operator',
      'delivery-registrations-operator',
      'gogocare-registrations-operator',
      'research-registrations-operator',
      'partnership-caller-registrations-operator',
      'homeServices-registrations-operator',
      'facebookLeads-registrations-operator',
      'overseas-operator',
      'family',
      'customer',
    ],
  },
  {
    pageId: 'partner',
    allowedRoles: ['admin', 'partner'],
  },
  {
    pageId: 'affiliate',
    allowedRoles: ['admin', 'affiliate'],
  },
];

export const genderList: ListType[] = [
  { id: 1, key: 'Male', label: 'Male' },
  { id: 2, key: 'Female', label: 'Female' },
];

export const yesNoOptions: ListType[] = [
  { id: 1, key: YesNoEnum.Yes, label: 'Yes' },
  { id: 2, key: YesNoEnum.No, label: 'No' },
];

// Define the allowed tags and attributes for sanitization.
export const ALLOWED_TAGS = ['a', 'br', 'em', 'h1', 'h2', 'h3', 'li', 'ol', 'p', 'span', 'strong', 'u', 'ul', 'div', 'b', 'i'];
export const ALLOWED_ATTR = ['href', 'rel', 'target', 'class', 'style'];
